import React, { useState } from 'react'
import Modal from '../../Modal'
import Button from '../../Button'

import Icon from '../../Icon'
import { MessageCreate } from '../type'
import { Actions, ModalContent as Container, Geolocation as IFrame } from './styles'
import useLocation from '../../../hooks/use-location'

interface Props {
  onChange: (message: MessageCreate) => void
}

const Geolocation: React.FC<Props> = ({ onChange }) => {
  const [open, setOpen] = useState(false)
  const { location, requestingLocation, requestLocation } = useLocation()

  return (
    <>
      <Button
        before={(
          <Icon
            name="geolocation"
          />
        )}
        label="Enviar localização"
        backgroundColor="transparent"
        fontColor="darkGray"
        smallPadding
        alignText="flex-start"
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        onToggle={open => setOpen(open)}
      >
        <Container>
          {location ? (
            <>
              <IFrame
                src={`https://maps.google.com/maps?q=${location.latitude},${location.longitude}&z=15&output=embed`}
                width="250"
                height="200"
                frameBorder="0"
                style={{
                  border: 0,
                }}
              ></IFrame>

              <Actions>
                <Button
                  label="ESCOLHER LOCALIZAÇÃO"
                  onClick={() => {
                    onChange({
                      type: 'GEOLOCATION',
                      geolocation: location,
                    })
                    setOpen(false)
                  }}
                />
              </Actions>
            </>
          ) : requestingLocation ? (
            <span>Aguarde...</span>
          ) : (
            <Button
              label="REQUISITAR LOCALIZAÇÃO"
              onClick={requestLocation}
            />
          )}
        </Container>
      </Modal>
    </>
  )
}

export default Geolocation
